import { useCallback, useEffect, useState } from 'react';

import { type Environment } from '../server/utils/environment';
import { type NudataOnCompleted, type NudataOnError, setupNudata, teardownNudata } from '../server/vendors';

export const SELECTOR = 'nudata-target';

export interface NudataProps {
	environment: Environment;
	onCompleted: NudataOnCompleted;
	placement?: string;
}

export function Nudata(props: NudataProps) {
	const { environment, onCompleted, placement } = props;
	const [initialized, setInitialized] = useState<boolean>(false);
	const [errored, setErrored] = useState<boolean>(false);

	const internalOnCompleted = useCallback<NudataOnCompleted>(
		sessionToken => {
			setInitialized(true);
			onCompleted(sessionToken);
		},
		[onCompleted, setInitialized],
	);

	const onError = useCallback<NudataOnError>(() => {
		setErrored(true);
	}, [setErrored]);

	useEffect(() => {
		if (!initialized && !errored) {
			teardownNudata();
			setupNudata({ environment, onCompleted: internalOnCompleted, onError, placement });
		}
	}, [environment, errored, initialized, internalOnCompleted, onError, placement]);

	return <div data-testid={SELECTOR} id={SELECTOR}></div>;
}
